import { Link } from 'react-router-dom'

export default function Terms() {
  return (
    <div className="section max-w-3xl">
      <h1 className="font-display text-3xl text-civitas-navy mb-2">Terms of Service</h1>
      <p className="text-xs text-civitas-silver mb-8">Last updated: October 29, 2026 · Virginia &amp; Delaware 2026 Pilot</p>

      <div className="mb-8 rounded-lg border border-civitas-silver/30 bg-civitas-light/40 p-4 text-sm text-civitas-silver">
        Signed up as a beta tester, advisor, or consultant? That relationship is governed by the
        separate{' '}
        <Link to="/beta-agreement?view=1" className="font-semibold text-civitas-navy underline">
          BECivitas Participation Agreement
        </Link>{' '}
        you accepted at signup, which covers confidentiality, IP assignment, and beta-specific terms
        not addressed below.
      </div>

      {[
        {
          title: '1. Acceptance',
          content: `By using BECivitas ("the Service"), operated by BECivitas, Inc., a Delaware corporation ("the Company"), you agree to these Terms of Service.
          If you do not agree, please do not use the Service. These terms apply to the 2026 Pilot only.`
        },
        {
          title: '2. Non-Partisan Commitment',
          content: `BECivitas is a non-partisan civic information platform. Candidate data is sourced 
          from official public records. We do not endorse, support, or oppose any candidate, political party, 
          or political position. Match scores reflect algorithmic alignment only and are not voting recommendations.`
        },
        {
          title: '3. Data Accuracy',
          content: `While we strive for accuracy, candidate position data may not reflect the most recent 
          developments. Always verify important information with primary sources. Evidence Ledger entries 
          include confidence scores to help you assess data quality. We are not responsible for decisions 
          made based on the platform's output.`
        },
        {
          title: '4. Acceptable Use',
          content: `You may use the Service for personal civic education. You may not: scrape or automate 
          access to the Service, attempt to reverse-engineer the matching algorithm for commercial use, 
          use the Service to spread misinformation, or violate any applicable laws.`
        },
        {
          title: '5. Intellectual Property',
          content: `The BECivitas matching algorithm, design, and codebase are proprietary. 
          Candidate data sourced from public records remains public. User-generated content (feedback, 
          reports) submitted to the platform may be used to improve the Service.`
        },
        {
          title: '6. Disclaimers',
          content: `The Service is provided "as is" for informational purposes only. BECivitas makes 
          no warranties about accuracy, completeness, or fitness for a particular purpose. Match scores 
          are algorithmic outputs, not expert political analysis.`
        },
        {
          title: '7. Limitation of Liability',
          content: `BECivitas is not liable for any damages arising from use of the Service, including 
          voting decisions made in reliance on the platform's output. Maximum liability is limited to $0 
          for users of the free tier.`
        },
        {
          title: '8. Changes',
          content: `We may update these Terms. Continued use after changes constitutes acceptance. 
          Material changes will be communicated via the platform.`
        },
        {
          title: '9. Contact',
          content: `For questions about these Terms, contact: adam12beck@gmail.com`
        },
      ].map(({ title, content }) => (
        <div key={title} className="mb-6">
          <h2 className="font-semibold text-civitas-navy mb-2">{title}</h2>
          <p className="text-sm text-civitas-silver leading-relaxed">{content}</p>
        </div>
      ))}
    </div>
  )
}
